// ── CONFIG — replace with your real Klaviyo values ──
var KLAVIYO_LIST_ID    = 'UGqLdf';
var KLAVIYO_COMPANY_ID = 'YOUR_COMPANY_ID';
var TOTAL_STEPS        = 3;

// ── STATE ──
var mtscAnswers = {
  gender: null,
  height: null,       // cm value as string
  heightUnit: 'cm',
  weight: null,       // kg value as string
  weightUnit: 'kg',
  age: null,
  abdomen: null,
  hips: null,
  fit: null
};
var mtscCurrentStep = 1;

// ── HELPERS ──
function mtscCmToInLabel(cm) {
  var totalIn = Math.round(cm / 2.54);
  return Math.floor(totalIn / 12) + '\'' + (totalIn % 12) + '"';
}

function mtscUpdateProgress(step) {
  var pct = Math.round((step / TOTAL_STEPS) * 100);
  var lbl  = document.getElementById('mtscProgressLabel');
  var pctEl = document.getElementById('mtscProgressPct');
  var fill  = document.getElementById('mtscProgressFill');
  if (lbl)   lbl.textContent  = 'Step ' + step + ' of ' + TOTAL_STEPS;
  if (pctEl) pctEl.textContent = pct + '%';
  if (fill)  fill.style.width  = pct + '%';
}

function mtscScrollTop() {
  var drawer = document.getElementById('mtscDrawer');
  if (drawer) drawer.scrollTop = 0;
}

function mtscHeightOptions(unit, selectedVal) {
  var opts = '<option value="">Select height</option>';
  for (var cm = 140; cm <= 220; cm++) {
    var sel   = (selectedVal && selectedVal == cm) ? ' selected' : '';
    var label = unit === 'cm' ? cm + ' cm' : mtscCmToInLabel(cm);
    opts += '<option value="' + cm + '"' + sel + '>' + label + '</option>';
  }
  return opts;
}

function mtscWeightOptions(unit, selectedVal) {
  var opts = '<option value="">Select weight</option>';
  for (var kg = 40; kg <= 160; kg++) {
    var sel   = (selectedVal && selectedVal == kg) ? ' selected' : '';
    var label = unit === 'kg' ? kg + ' kg' : Math.round(kg * 2.205) + ' lbs';
    opts += '<option value="' + kg + '"' + sel + '>' + label + '</option>';
  }
  return opts;
}

function mtscAgeOptions(selectedVal) {
  var opts = '<option value="">Select age</option>';
  for (var a = 14; a <= 80; a++) {
    var sel = (selectedVal && selectedVal == a) ? ' selected' : '';
    opts += '<option value="' + a + '"' + sel + '>' + a + '</option>';
  }
  return opts;
}

function mtscCheckPage1() {
  var btn = document.getElementById('mtscNext1');
  if (btn) btn.disabled = !(mtscAnswers.gender && mtscAnswers.height && mtscAnswers.weight && mtscAnswers.age);
}

function mtscCheckPage2() {
  var btn = document.getElementById('mtscNext2');
  if (btn) btn.disabled = !(mtscAnswers.abdomen && mtscAnswers.hips);
}

// ── SIZE ENGINE (placeholder) ──
function mtscCalcSize() {
  return { label: 'M', num: 12 };
}

// ── FIT SVGs ──
var mtscFitSVGs = {
  fitted:    '<svg width="32" height="48" viewBox="0 0 36 52" fill="none"><ellipse cx="18" cy="6" rx="6" ry="6" fill="currentColor"/><path d="M10 8 C10 3 26 3 26 8 L28 28 C28 30 24 32 18 32 C12 32 8 30 8 28 Z" fill="currentColor" opacity=".85"/><rect x="9" y="32" width="7" height="18" rx="1" fill="currentColor" opacity=".7"/><rect x="20" y="32" width="7" height="18" rx="1" fill="currentColor" opacity=".7"/></svg>',
  regular:   '<svg width="32" height="48" viewBox="0 0 36 52" fill="none"><ellipse cx="18" cy="6" rx="6" ry="6" fill="currentColor"/><path d="M8 8 C8 3 28 3 28 8 L30 28 C30 30 25 33 18 33 C11 33 6 30 6 28 Z" fill="currentColor" opacity=".85"/><rect x="7" y="33" width="8" height="18" rx="1" fill="currentColor" opacity=".7"/><rect x="21" y="33" width="8" height="18" rx="1" fill="currentColor" opacity=".7"/></svg>',
  oversized: '<svg width="32" height="48" viewBox="0 0 36 52" fill="none"><ellipse cx="18" cy="6" rx="6" ry="6" fill="currentColor"/><path d="M4 8 C4 2 32 2 32 8 L34 28 C34 31 27 35 18 35 C9 35 2 31 2 28 Z" fill="currentColor" opacity=".85"/><rect x="4" y="35" width="9" height="16" rx="1" fill="currentColor" opacity=".7"/><rect x="23" y="35" width="9" height="16" rx="1" fill="currentColor" opacity=".7"/></svg>'
};

// ── OPEN ──
window.mtscOpen = function() {
  var existing = document.getElementById('mtscOverlay');
  if (!existing) {
    var el = document.createElement('div');
    el.id = 'mtscOverlay';
    el.className = 'mtsc-overlay';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Find your size');
    el.innerHTML = [
      '<div style="position:absolute;inset:0;" onclick="mtscClose()"></div>',
      '<div class="mtsc-drawer" id="mtscDrawer">',
        '<div class="mtsc-drawer-header">',
          '<span class="mtsc-drawer-title">Take our fit quiz</span>',
          '<button class="mtsc-close" onclick="mtscClose()" aria-label="Close">',
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none">',
              '<path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>',
            '</svg>',
          '</button>',
        '</div>',
        '<div class="mtsc-body">',
          '<div id="mtscMemory" class="mtsc-memory mtsc-hidden">',
            '<p class="mtsc-memory-text">Welcome back — your saved size is <strong id="mtscMemoryLabel"></strong>.</p>',
            '<div class="mtsc-memory-actions">',
              '<button class="mtsc-memory-btn mtsc-primary" onclick="mtscUseMemory()">Use this</button>',
              '<button class="mtsc-memory-btn" onclick="mtscRetake()">Retake</button>',
            '</div>',
          '</div>',
          '<div id="mtscProgressWrap">',
            '<div class="mtsc-progress-meta">',
              '<span class="mtsc-progress-label" id="mtscProgressLabel">Step 1 of 4</span>',
              '<span class="mtsc-progress-label" id="mtscProgressPct">0%</span>',
            '</div>',
            '<div class="mtsc-progress-track">',
              '<div class="mtsc-progress-fill" id="mtscProgressFill" style="width:0%"></div>',
            '</div>',
          '</div>',
          '<div id="mtscQuiz"></div>',
          '<div id="mtscResult" class="mtsc-hidden"></div>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(el);
  }
  var overlay = document.getElementById('mtscOverlay');
  overlay.classList.add('mtsc-open');
  document.body.style.overflow = 'hidden';
  mtscCheckMemory();
  mtscRender(1);
};

// ── CLOSE ──
window.mtscClose = function() {
  var overlay = document.getElementById('mtscOverlay');
  if (overlay) overlay.classList.remove('mtsc-open');
  document.body.style.overflow = '';
};

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') mtscClose();
});

document.addEventListener('DOMContentLoaded', function() {
  try {
    var saved = localStorage.getItem('mtsc_size');
    if (saved) {
      var mem = JSON.parse(saved);
      if (mem && mem.result && mem.result.label) mtscUpdateTrigger(mem.result.label);
    }
  } catch(e) {}
});

// ── RENDER ──
window.mtscRender = function(step) {
  mtscCurrentStep = step;
  mtscUpdateProgress(step);
  var result   = document.getElementById('mtscResult');
  var progress = document.getElementById('mtscProgressWrap');
  if (result)   result.classList.add('mtsc-hidden');
  if (progress) progress.classList.remove('mtsc-hidden');
  mtscScrollTop();

  var html = '';

  // ── PAGE 1: Basic information ──
  if (step === 1) {
    var p1ready = mtscAnswers.gender && mtscAnswers.height && mtscAnswers.weight && mtscAnswers.age;
    html =
      '<h2 class="mtsc-q-text">Basic information</h2>' +

      '<div class="mtsc-page-section">' +
        '<p class="mtsc-field-label">I am a</p>' +
        '<div class="mtsc-gender-opts">' +
          '<button class="mtsc-gender-btn' + (mtscAnswers.gender === 'man'   ? ' mtsc-sel' : '') + '" onclick="mtscSelGender(\'man\')">Man</button>' +
          '<button class="mtsc-gender-btn' + (mtscAnswers.gender === 'woman' ? ' mtsc-sel' : '') + '" onclick="mtscSelGender(\'woman\')">Woman</button>' +
        '</div>' +
      '</div>' +

      '<div class="mtsc-page-section">' +
        '<p class="mtsc-field-label">Height</p>' +
        '<div class="mtsc-field-row">' +
          '<select class="mtsc-select" id="mtscHeightSel" onchange="mtscUpdHeight(this.value)">' +
            mtscHeightOptions(mtscAnswers.heightUnit, mtscAnswers.height) +
          '</select>' +
          '<div class="mtsc-unit-toggle">' +
            '<button class="mtsc-unit-btn mtsc-height-unit-btn' + (mtscAnswers.heightUnit === 'cm' ? ' mtsc-unit-active' : '') + '" data-unit="cm" onclick="mtscToggleHeightUnit(\'cm\')">cm</button>' +
            '<button class="mtsc-unit-btn mtsc-height-unit-btn' + (mtscAnswers.heightUnit === 'in' ? ' mtsc-unit-active' : '') + '" data-unit="in" onclick="mtscToggleHeightUnit(\'in\')">in</button>' +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="mtsc-page-section">' +
        '<p class="mtsc-field-label">Weight</p>' +
        '<div class="mtsc-field-row">' +
          '<select class="mtsc-select" id="mtscWeightSel" onchange="mtscUpdWeight(this.value)">' +
            mtscWeightOptions(mtscAnswers.weightUnit, mtscAnswers.weight) +
          '</select>' +
          '<div class="mtsc-unit-toggle">' +
            '<button class="mtsc-unit-btn mtsc-weight-unit-btn' + (mtscAnswers.weightUnit === 'kg'  ? ' mtsc-unit-active' : '') + '" data-unit="kg"  onclick="mtscToggleWeightUnit(\'kg\')">kg</button>' +
            '<button class="mtsc-unit-btn mtsc-weight-unit-btn' + (mtscAnswers.weightUnit === 'lbs' ? ' mtsc-unit-active' : '') + '" data-unit="lbs" onclick="mtscToggleWeightUnit(\'lbs\')">lbs</button>' +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="mtsc-page-section">' +
        '<p class="mtsc-field-label">Age</p>' +
        '<select class="mtsc-select mtsc-select-age" id="mtscAgeSel" onchange="mtscUpdAge(this.value)">' +
          mtscAgeOptions(mtscAnswers.age) +
        '</select>' +
      '</div>' +

      '<div class="mtsc-nav">' +
        '<button class="mtsc-btn-next" id="mtscNext1" onclick="mtscRender(2)"' + (p1ready ? '' : ' disabled') + '>Continue</button>' +
      '</div>';

  // ── PAGE 2: Body shape ──
  } else if (step === 2) {
    var p2ready   = mtscAnswers.abdomen && mtscAnswers.hips;
    var abdoOpts  = ['flat', 'medium', 'bulging'];
    var hipOpts   = ['straight', 'tight', 'wide'];

    html = '<h2 class="mtsc-q-text">Body shape</h2>';

    html += '<div class="mtsc-page-section">' +
              '<p class="mtsc-field-label">Shape of your abdomen</p>' +
              '<div class="mtsc-shape-opts" id="mtscAbdomenOpts">';
    for (var i = 0; i < abdoOpts.length; i++) {
      var av = abdoOpts[i];
      html += '<button class="mtsc-shape-btn' + (mtscAnswers.abdomen === av ? ' mtsc-sel' : '') + '" onclick="mtscSelAbdomen(\'' + av + '\')">' + av.charAt(0).toUpperCase() + av.slice(1) + '</button>';
    }
    html += '</div></div>';

    html += '<div class="mtsc-page-section">' +
              '<p class="mtsc-field-label">Shape of your hips</p>' +
              '<div class="mtsc-shape-opts" id="mtscHipOpts">';
    for (var j = 0; j < hipOpts.length; j++) {
      var hv = hipOpts[j];
      html += '<button class="mtsc-shape-btn' + (mtscAnswers.hips === hv ? ' mtsc-sel' : '') + '" onclick="mtscSelHips(\'' + hv + '\')">' + hv.charAt(0).toUpperCase() + hv.slice(1) + '</button>';
    }
    html += '</div></div>';

    html += '<div class="mtsc-nav">' +
              '<button class="mtsc-btn-back" onclick="mtscRender(1)">Back</button>' +
              '<button class="mtsc-btn-next" id="mtscNext2" onclick="mtscRender(3)"' + (p2ready ? '' : ' disabled') + '>Continue</button>' +
            '</div>';

  // ── PAGE 3: Fit preference ──
  } else if (step === 3) {
    var fits = [
      { val: 'fitted',    label: 'Fitted',    sub: 'Close to the body' },
      { val: 'regular',   label: 'Regular',   sub: 'Easy through the chest' },
      { val: 'oversized', label: 'Oversized', sub: 'Relaxed and roomy' }
    ];
    html = '<h2 class="mtsc-q-text">How do you like to wear your clothes?</h2>' +
           '<div class="mtsc-fit-opts">';
    for (var k = 0; k < fits.length; k++) {
      var f = fits[k];
      var isSel      = mtscAnswers.fit === f.val;
      var svgContent = mtscFitSVGs[f.val].replace(/currentColor/g, isSel ? '#F5F0E8' : '#1E1C18');
      html += '<button class="mtsc-fit-btn' + (isSel ? ' mtsc-sel' : '') + '" onclick="mtscSelFit(\'' + f.val + '\')">' +
              svgContent +
              '<span class="mtsc-fit-label">' + f.label + '</span>' +
              '<span class="mtsc-fit-sub">' + f.sub + '</span>' +
              '</button>';
    }
    html += '</div>' +
            '<div class="mtsc-nav">' +
              '<button class="mtsc-btn-back" onclick="mtscRender(2)">Back</button>' +
              '<button class="mtsc-btn-next" id="mtscNext3" onclick="mtscShowResult()"' + (mtscAnswers.fit ? '' : ' disabled') + '>See my size</button>' +
            '</div>';
  }

  var quiz = document.getElementById('mtscQuiz');
  if (quiz) quiz.innerHTML = html;
};

// ── ANSWER SETTERS ──
window.mtscSelGender = function(v) {
  mtscAnswers.gender = v;
  document.querySelectorAll('.mtsc-gender-btn').forEach(function(btn) {
    btn.classList.toggle('mtsc-sel', btn.textContent.trim().toLowerCase() === v);
  });
  mtscCheckPage1();
};

window.mtscUpdHeight = function(v) {
  mtscAnswers.height = v || null;
  mtscCheckPage1();
};

window.mtscToggleHeightUnit = function(unit) {
  mtscAnswers.heightUnit = unit;
  document.querySelectorAll('.mtsc-height-unit-btn').forEach(function(btn) {
    btn.classList.toggle('mtsc-unit-active', btn.dataset.unit === unit);
  });
  var sel = document.getElementById('mtscHeightSel');
  if (sel) {
    var cur = sel.value;
    sel.innerHTML = mtscHeightOptions(unit, cur);
  }
};

window.mtscUpdWeight = function(v) {
  mtscAnswers.weight = v || null;
  mtscCheckPage1();
};

window.mtscToggleWeightUnit = function(unit) {
  mtscAnswers.weightUnit = unit;
  document.querySelectorAll('.mtsc-weight-unit-btn').forEach(function(btn) {
    btn.classList.toggle('mtsc-unit-active', btn.dataset.unit === unit);
  });
  var sel = document.getElementById('mtscWeightSel');
  if (sel) {
    var cur = sel.value;
    sel.innerHTML = mtscWeightOptions(unit, cur);
  }
};

window.mtscUpdAge = function(v) {
  mtscAnswers.age = v || null;
  mtscCheckPage1();
};

window.mtscSelAbdomen = function(v) {
  mtscAnswers.abdomen = v;
  document.querySelectorAll('#mtscAbdomenOpts .mtsc-shape-btn').forEach(function(btn) {
    btn.classList.toggle('mtsc-sel', btn.textContent.trim().toLowerCase() === v);
  });
  mtscCheckPage2();
};

window.mtscSelHips = function(v) {
  mtscAnswers.hips = v;
  document.querySelectorAll('#mtscHipOpts .mtsc-shape-btn').forEach(function(btn) {
    btn.classList.toggle('mtsc-sel', btn.textContent.trim().toLowerCase() === v);
  });
  mtscCheckPage2();
};

window.mtscSelFit = function(v) {
  mtscAnswers.fit = v;
  document.querySelectorAll('.mtsc-fit-btn').forEach(function(btn) {
    var isSel = btn.getAttribute('onclick').indexOf("'" + v + "'") !== -1;
    btn.classList.toggle('mtsc-sel', isSel);
    var svg = btn.querySelector('svg');
    if (svg) svg.style.color = isSel ? '#F5F0E8' : '#1E1C18';
  });
  var nextBtn = document.getElementById('mtscNext3');
  if (nextBtn) nextBtn.disabled = false;
};

// ── RESULT ──
window.mtscShowResult = function() {
  var result = mtscCalcSize();
  var mem = {};
  for (var key in mtscAnswers) { mem[key] = mtscAnswers[key]; }
  mem.result = result;
  localStorage.setItem('mtsc_size', JSON.stringify(mem));
  mtscUpdateTrigger(result.label);

  var quiz     = document.getElementById('mtscQuiz');
  var progress = document.getElementById('mtscProgressWrap');
  if (quiz)     quiz.innerHTML = '';
  if (progress) progress.classList.add('mtsc-hidden');

  var fitNotes = {
    fitted:    'This size sits close to your body with minimal ease through the chest and sleeve.',
    regular:   'This gives you comfortable ease through the chest and shoulders — our most popular fit.',
    oversized: 'A relaxed, dropped silhouette with room to layer underneath.'
  };
  var genderNotes = {
    man:   'This is our standard cut — room through the shoulders, straight through the body.',
    woman: 'This is our standard cut — slightly tapered through the waist.'
  };
  var fitLabel    = mtscAnswers.fit.charAt(0).toUpperCase() + mtscAnswers.fit.slice(1);
  var genderNote  = genderNotes[mtscAnswers.gender] || '';
  var fitNote     = fitNotes[mtscAnswers.fit] || '';

  var resultEl = document.getElementById('mtscResult');
  if (resultEl) {
    resultEl.classList.remove('mtsc-hidden');
    resultEl.innerHTML =
      '<div class="mtsc-result-card">' +
        '<span class="mtsc-result-eyebrow">Your size is</span>' +
        '<p class="mtsc-result-title">We recommend</p>' +
        '<div class="mtsc-result-size">' + result.label + '</div>' +
        '<p class="mtsc-result-range">' + fitLabel + ' fit</p>' +
        '<p class="mtsc-result-note">' + genderNote + '</p>' +
        '<p class="mtsc-result-note">' + fitNote + '</p>' +
        '<button class="mtsc-btn-add-size" onclick="mtscAddSizeToCart()">Add size ' + result.label + ' to basket</button>' +
      '</div>' +
      '<div class="mtsc-email-card" id="mtscEmailCard">' +
        '<h3 class="mtsc-email-title">Check your inbox.</h3>' +
        '<p class="mtsc-email-sub">Your size is waiting for you there — and so is a small thank-you from us.</p>' +
        '<div class="mtsc-email-row">' +
          '<input class="mtsc-email-input" type="email" id="mtscEmailInput" placeholder="your@email.com">' +
          '<button class="mtsc-email-submit" onclick="mtscSubmitEmail()">Save it</button>' +
        '</div>' +
      '</div>';
  }
  mtscScrollTop();
};

// ── KLAVIYO ──
window.mtscSubmitEmail = function() {
  var emailInput = document.getElementById('mtscEmailInput');
  if (!emailInput) return;
  var email = emailInput.value.trim();
  if (!email || email.indexOf('@') === -1) {
    emailInput.style.borderColor = '#c0392b';
    return;
  }
  var result  = mtscCalcSize();
  var payload = {
    data: {
      type: 'subscription',
      attributes: {
        list_id: KLAVIYO_LIST_ID,
        email: email,
        custom_source: 'Size Quiz',
        properties: {
          gender:         mtscAnswers.gender,
          height:         mtscAnswers.height,
          height_unit:    mtscAnswers.heightUnit,
          weight:         mtscAnswers.weight,
          weight_unit:    mtscAnswers.weightUnit,
          age:            mtscAnswers.age,
          abdomen_shape:  mtscAnswers.abdomen,
          hip_shape:      mtscAnswers.hips,
          fit_preference: mtscAnswers.fit,
          size_label:     result.label,
          quiz_completed: true
        }
      }
    }
  };
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
    body: JSON.stringify(payload)
  }).catch(function(e) { console.warn('Klaviyo error:', e); });

  var card = document.getElementById('mtscEmailCard');
  if (card) {
    card.innerHTML = '<div class="mtsc-email-success">We\'ll send an email to help you remember your size for next time.</div>';
  }
};

// ── MEMORY ──
function mtscCheckMemory() {
  var saved = localStorage.getItem('mtsc_size');
  if (!saved) return;
  try {
    var mem = JSON.parse(saved);
    if (!mem.result) return;
    var lbl    = document.getElementById('mtscMemoryLabel');
    var banner = document.getElementById('mtscMemory');
    if (lbl)    lbl.textContent = mem.result.label + ' (' + (mem.fit || '') + ' fit)';
    if (banner) banner.classList.remove('mtsc-hidden');
    for (var key in mem) { mtscAnswers[key] = mem[key]; }
  } catch(e) {}
}

window.mtscUseMemory = function() {
  var saved = localStorage.getItem('mtsc_size');
  if (!saved) return;
  var mem    = JSON.parse(saved);
  var banner = document.getElementById('mtscMemory');
  var quiz   = document.getElementById('mtscQuiz');
  var progress = document.getElementById('mtscProgressWrap');
  if (banner)   banner.classList.add('mtsc-hidden');
  if (quiz)     quiz.innerHTML = '';
  if (progress) progress.classList.add('mtsc-hidden');
  for (var key in mem) { mtscAnswers[key] = mem[key]; }
  mtscShowResult();
};

// ── TRIGGER LABEL ──
function mtscUpdateTrigger(label) {
  var span = document.querySelector('.mtsc-trigger-link span');
  if (span) span.textContent = 'Your Size is ' + label;
}

window.mtscAddSizeToCart = function() {
  var dataEl = document.getElementById('mtsc-product-data');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var result = mtscCalcSize();
  var lowerOptions = data.options.map(function(o) { return o.toLowerCase(); });
  var sizeIdx = lowerOptions.indexOf('size');
  if (sizeIdx === -1) sizeIdx = 0;
  var sizeKey = 'option' + (sizeIdx + 1);

  var target = null;
  for (var i = 0; i < data.variants.length; i++) {
    if (data.variants[i][sizeKey] === result.label && data.variants[i].available) {
      target = data.variants[i];
      break;
    }
  }
  if (!target) {
    for (var j = 0; j < data.variants.length; j++) {
      if (data.variants[j][sizeKey] === result.label) { target = data.variants[j]; break; }
    }
  }
  if (!target && data.variants.length) target = data.variants[0];
  if (!target) return;

  var btn = document.querySelector('.mtsc-btn-add-size');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: target.id,
      quantity: 1,
      properties: { '_quiz_added': '1' },
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(function(r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
  .then(function(state) {
    mtscClose();
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && state.sections) cartDrawer.renderContents(state);
    document.dispatchEvent(new CustomEvent('mtsc:quiz-added', { detail: { variantId: target.id } }));
  })
  .catch(function() {
    if (btn) { btn.disabled = false; btn.textContent = 'Add size ' + result.label + ' to basket'; }
  });
};

window.mtscRetake = function() {
  localStorage.removeItem('mtsc_size');
  mtscAnswers = {
    gender: null, height: null, heightUnit: 'cm',
    weight: null, weightUnit: 'kg', age: null,
    abdomen: null, hips: null, fit: null
  };
  var banner = document.getElementById('mtscMemory');
  if (banner) banner.classList.add('mtsc-hidden');
  mtscRender(1);
};
